import { PreviewCart } from "../components/cart/preview-cart";

window.addToCart = function(
  id: number | string,
  qty: number
){
  const previewCart = new PreviewCart();

  previewCart.addItem(`${id}`, qty)
  .then((data: any) => {
      if (data.status && data.status >= 400) {
          previewCart.closePreviewCart();
      }
      else {
          previewCart.refreshPreviewCart(data);
      }
  })
  .catch((error) => {
      console.error("error", error)
  })
}

window.openCart = function(){
  const previewCart = new PreviewCart();
  previewCart.openPreviewCart(true);
}